const corinthians = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 26/27 - Uniforme 2 Pré Jogo",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/26-27-05-pj/cor0.jpg",
      "/images/brasil/serie-a/corinthians/26-27-05-pj/cor1.jpg",
      "/images/brasil/serie-a/corinthians/26-27-05-pj/cor2.jpg",
      "/images/brasil/serie-a/corinthians/26-27-05-pj/cor3.jpg",
      "/images/brasil/serie-a/corinthians/26-27-05-pj/cor4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 25/26 - Uniforme Edição Especial",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/25-26-00-es/cor0.jpg",
      "/images/brasil/serie-a/corinthians/25-26-00-es/cor1.jpg",
      "/images/brasil/serie-a/corinthians/25-26-00-es/cor2.jpg",
      "/images/brasil/serie-a/corinthians/25-26-00-es/cor3.jpg",
      "/images/brasil/serie-a/corinthians/25-26-00-es/cor4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 25/26 - Uniforme 1",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/25-26-01/cor0.jpg",
      "/images/brasil/serie-a/corinthians/25-26-01/cor1.jpg",
      "/images/brasil/serie-a/corinthians/25-26-01/cor2.jpg",
      "/images/brasil/serie-a/corinthians/25-26-01/cor3.jpg",
      "/images/brasil/serie-a/corinthians/25-26-01/cor4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 25/26 - Uniforme 2",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/25-26-02/cor0.jpg",
      "/images/brasil/serie-a/corinthians/25-26-02/cor1.jpg",
      "/images/brasil/serie-a/corinthians/25-26-02/cor2.jpg",
      "/images/brasil/serie-a/corinthians/25-26-02/cor3.jpg",
      "/images/brasil/serie-a/corinthians/25-26-02/cor4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 25/26 - Uniforme 3",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/25-26-03/cor0.jpg",
      "/images/brasil/serie-a/corinthians/25-26-03/cor1.jpg",
      "/images/brasil/serie-a/corinthians/25-26-03/cor2.jpg",
      "/images/brasil/serie-a/corinthians/25-26-03/cor3.jpg",
      "/images/brasil/serie-a/corinthians/25-26-03/cor4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 25/26 - Uniforme de Goleiro (Amarela)",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/25-26-05-ga/cor0.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-ga/cor1.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-ga/cor2.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-ga/cor3.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-ga/cor4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 25/26 - Uniforme de Goleiro (Preta)",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/25-26-05-gp/cor0.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-gp/cor1.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-gp/cor2.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-gp/cor3.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-gp/cor4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 25/26 - Uniforme Pré Jogo (Cinza) ",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/25-26-05-pj/cor0.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-pj/cor1.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-pj/cor2.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-pj/cor3.jpg",
      "/images/brasil/serie-a/corinthians/25-26-05-pj/cor4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Regata (Preta)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "corinthians 2024",
      "regata",
      "regata Corinthians",
      "corinthians regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-00-re/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-00-re/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-00-re/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-00-re/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-00-re/cor4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Uniforme 1",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-01/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01/cor4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Uniforme 1 (Feminina)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "corinthians 2024",
      "feminino",
      "corinthians feminino",
      "feminino corinthians",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-01-f/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01-f/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01-f/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01-f/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01-f/cor4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Regata (Branca)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "corinthians 2024",
      "regata",
      "regata Corinthians",
      "corinthians regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-01-re/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01-re/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01-re/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01-re/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-01-re/cor4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Uniforme 2",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-02/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02/cor4.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Uniforme 2 (Feminina)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "corinthians 2024",
      "feminino",
      "corinthians feminino",
      "feminino corinthians",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-02-f/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02-f/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02-f/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02-f/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02-f/cor4.jpg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Calção (Preto)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "corinthians 2024",
      "calção",
      "shorts",
      "corinthians calção",
      "calção corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-02-c/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02-c/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02-c/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02-c/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-02-c/cor4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Uniforme 3",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-03/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-03/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-03/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-03/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-03/cor4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Uniforme 3 (Feminina)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "corinthians 2024",
      "feminino",
      "corinthians feminino",
      "feminino corinthians",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-03-f/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-03-f/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-03-f/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-03-f/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-03-f/cor4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Uniforme de Goleiro (Amarela)",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-05-ga/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-05-ga/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-05-ga/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-05-ga/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-05-ga/cor4.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Uniforme de Goleiro (Azul)",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-05-gaz/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-05-gaz/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-05-gaz/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-05-gaz/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-05-gaz/cor4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 24/25 - Uniforme Pré Jogo",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/24-25-06-pj/cor0.jpg",
      "/images/brasil/serie-a/corinthians/24-25-06-pj/cor1.jpg",
      "/images/brasil/serie-a/corinthians/24-25-06-pj/cor2.jpg",
      "/images/brasil/serie-a/corinthians/24-25-06-pj/cor3.jpg",
      "/images/brasil/serie-a/corinthians/24-25-06-pj/cor4.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 23/24 - Uniforme 1",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/23-24-01/cor0.jpg",
      "/images/brasil/serie-a/corinthians/23-24-01/cor1.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 23/24 - Uniforme 2",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/23-24-02/cor0.jpg",
      "/images/brasil/serie-a/corinthians/23-24-02/cor1.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 23/24 - Uniforme 3",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/23-24-03/cor0.jpg",
      "/images/brasil/serie-a/corinthians/23-24-03/cor1.jpg",
      "/images/brasil/serie-a/corinthians/23-24-03/cor2.jpg",
      "/images/brasil/serie-a/corinthians/23-24-03/cor3.jpg",
      "/images/brasil/serie-a/corinthians/23-24-03/cor4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 23/24 - Uniforme de Treino (Cinza)",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/23-24-05-tc/cor0.jpg",
      "/images/brasil/serie-a/corinthians/23-24-05-tc/cor1.jpg",
      "/images/brasil/serie-a/corinthians/23-24-05-tc/cor2.jpg",
      "/images/brasil/serie-a/corinthians/23-24-05-tc/cor3.jpg",
      "/images/brasil/serie-a/corinthians/23-24-05-tc/cor4.jpg",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 23/24 - Uniforme de Goleiro (Azul)",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/23-24-06-ga/cor0.jpg",
      "/images/brasil/serie-a/corinthians/23-24-06-ga/cor1.jpg",
      "/images/brasil/serie-a/corinthians/23-24-06-ga/cor2.jpg",
      "/images/brasil/serie-a/corinthians/23-24-06-ga/cor3.jpg",
    ],
  },
  {
    id: 26,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 22/23 - Regata (Preta)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "corinthians 2024",
      "regata",
      "regata Corinthians",
      "corinthians regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/22-23-00-re/cor0.jpg",
      "/images/brasil/serie-a/corinthians/22-23-00-re/cor1.jpg",
      "/images/brasil/serie-a/corinthians/22-23-00-re/cor2.jpg",
      "/images/brasil/serie-a/corinthians/22-23-00-re/cor3.jpg",
      "/images/brasil/serie-a/corinthians/22-23-00-re/cor4.jpg",
    ],
  },
  {
    id: 27,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 22/23 - Uniforme 1",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/22-23-01/cor0.jpg",
      "/images/brasil/serie-a/corinthians/22-23-01/cor1.jpg",
    ],
  },
  {
    id: 28,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 23/24 - Uniforme 1 (Feminina)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "corinthians 2024",
      "feminino",
      "corinthians feminino",
      "feminino corinthians",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/22-23-01-f/cor0.jpg",
      "/images/brasil/serie-a/corinthians/22-23-01-f/cor1.jpg",
      "/images/brasil/serie-a/corinthians/22-23-01-f/cor2.jpg",
      "/images/brasil/serie-a/corinthians/22-23-01-f/cor3.jpg",
      "/images/brasil/serie-a/corinthians/22-23-01-f/cor4.jpg",
    ],
  },
  {
    id: 29,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 22/23 - Uniforme 2",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/22-23-02/cor0.jpg",
      "/images/brasil/serie-a/corinthians/22-23-02/cor1.jpg",
      "/images/brasil/serie-a/corinthians/22-23-02/cor2.jpg",
      "/images/brasil/serie-a/corinthians/22-23-02/cor3.jpg",
      "/images/brasil/serie-a/corinthians/22-23-02/cor4.jpg",
    ],
  },
  {
    id: 30,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 22/23 - Uniforme 3",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/22-23-03/cor0.jpg",
      "/images/brasil/serie-a/corinthians/22-23-03/cor1.jpg",
      "/images/brasil/serie-a/corinthians/22-23-03/cor2.jpg",
      "/images/brasil/serie-a/corinthians/22-23-03/cor3.jpg",
      "/images/brasil/serie-a/corinthians/22-23-03/cor4.jpg",
    ],
  },
  {
    id: 31,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 22/23 - Uniforme de Treino (Preta)",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/22-23-04-tp/cor0.jpg",
      "/images/brasil/serie-a/corinthians/22-23-04-tp/cor1.jpg",
      "/images/brasil/serie-a/corinthians/22-23-04-tp/cor2.jpg",
      "/images/brasil/serie-a/corinthians/22-23-04-tp/cor3.jpg",
      "/images/brasil/serie-a/corinthians/22-23-04-tp/cor4.jpg",
    ],
  },
  {
    id: 32,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 22/23 - Uniforme de Pré Jogo",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/22-23-05-pj/cor0.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-pj/cor1.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-pj/cor2.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-pj/cor3.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-pj/cor4.jpg",
    ],
  },
  {
    id: 33,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 22/23 - Uniforme de Pré Jogo (Laranja)",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/22-23-05-pjl/cor0.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-pjl/cor1.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-pjl/cor2.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-pjl/cor3.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-pjl/cor4.jpg",
    ],
  },
  {
    id: 34,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 22/23 - Uniforme de Treino (Preta/Branca)",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/22-23-05-tpb/cor0.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-tpb/cor1.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-tpb/cor2.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-tpb/cor3.jpg",
      "/images/brasil/serie-a/corinthians/22-23-05-tpb/cor4.jpg",
    ],
  },
  {
    id: 35,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 21/22 - Uniforme 1",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/21-22-01/cor0.jpg",
      "/images/brasil/serie-a/corinthians/21-22-01/cor1.jpg",
      "/images/brasil/serie-a/corinthians/21-22-01/cor2.jpg",
      "/images/brasil/serie-a/corinthians/21-22-01/cor3.jpg",
      "/images/brasil/serie-a/corinthians/21-22-01/cor4.jpg",
    ],
  },
  {
    id: 36,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 21/22 - Uniforme 2",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/21-22-02/cor0.jpg",
      "/images/brasil/serie-a/corinthians/21-22-02/cor1.jpg",
      "/images/brasil/serie-a/corinthians/21-22-02/cor2.jpg",
      "/images/brasil/serie-a/corinthians/21-22-02/cor3.jpg",
      "/images/brasil/serie-a/corinthians/21-22-02/cor4.jpg",
    ],
  },
  {
    id: 37,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 21/22 - Uniforme 3",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/21-22-03/cor0.jpg",
      "/images/brasil/serie-a/corinthians/21-22-03/cor1.jpg",
      "/images/brasil/serie-a/corinthians/21-22-03/cor2.jpg",
      "/images/brasil/serie-a/corinthians/21-22-03/cor3.jpg",
      "/images/brasil/serie-a/corinthians/21-22-03/cor4.jpg",
    ],
  },
  {
    id: 38,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 21/22 - Uniforme de Goleiro (Amarela)",
    aliases: ["corinthians", "timão", "coringão", "corinthians 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/21-22-05-ga/cor0.jpg",
      "/images/brasil/serie-a/corinthians/21-22-05-ga/cor1.jpg",
      "/images/brasil/serie-a/corinthians/21-22-05-ga/cor2.jpg",
      "/images/brasil/serie-a/corinthians/21-22-05-ga/cor3.jpg",
      "/images/brasil/serie-a/corinthians/21-22-05-ga/cor4.jpg",
    ],
  },
  {
    id: 39,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 21/22 - Jaqueta Preta",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "jaqueta",
      "corinthians jaqueta",
      "jaqueta corinthians",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/21-22-00-jp/cor0.jpg",
      "/images/brasil/serie-a/corinthians/21-22-00-jp/cor1.jpg",
      "/images/brasil/serie-a/corinthians/21-22-00-jp/cor2.jpg",
      "/images/brasil/serie-a/corinthians/21-22-00-jp/cor3.jpg",
      "/images/brasil/serie-a/corinthians/21-22-00-jp/cor4.jpg",
    ],
  },
  {
    id: 40,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 19/20 - Uniforme 01 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/19-20-01-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/19-20-01-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/19-20-01-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/19-20-01-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/19-20-01-rt/cor4.jpg",
    ],
  },
  {
    id: 41,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 18/19 - Uniforme 03 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/18-19-03-re/cor0.jpg",
      "/images/brasil/serie-a/corinthians/18-19-03-re/cor1.jpg",
      "/images/brasil/serie-a/corinthians/18-19-03-re/cor2.jpg",
      "/images/brasil/serie-a/corinthians/18-19-03-re/cor3.jpg",
      "/images/brasil/serie-a/corinthians/18-19-03-re/cor4.jpg",
    ],
  },
  {
    id: 42,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 14/15 - Uniforme de Goleiro (Amarela) Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/14-15-05-ga/cor0.jpg",
      "/images/brasil/serie-a/corinthians/14-15-05-ga/cor1.jpg",
      "/images/brasil/serie-a/corinthians/14-15-05-ga/cor2.jpg",
      "/images/brasil/serie-a/corinthians/14-15-05-ga/cor3.jpg",
      "/images/brasil/serie-a/corinthians/14-15-05-ga/cor4.jpg",
    ],
  },
  {
    id: 43,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 12/13 - Uniforme Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/12-13-00-es/cor0.jpg",
      "/images/brasil/serie-a/corinthians/12-13-00-es/cor1.jpg",
      "/images/brasil/serie-a/corinthians/12-13-00-es/cor2.jpg",
      "/images/brasil/serie-a/corinthians/12-13-00-es/cor3.jpg",
      "/images/brasil/serie-a/corinthians/12-13-00-es/cor4.jpg",
    ],
  },
  {
    id: 44,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 11/12 - Uniforme 02 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/11-12-02-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/11-12-02-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/11-12-02-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/11-12-02-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/11-12-02-rt/cor4.jpg",
    ],
  },
  {
    id: 45,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 09/10 - Uniforme Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/09-10-00-re/cor0.jpg",
      "/images/brasil/serie-a/corinthians/09-10-00-re/cor1.jpg",
      "/images/brasil/serie-a/corinthians/09-10-00-re/cor2.jpg",
      "/images/brasil/serie-a/corinthians/09-10-00-re/cor3.jpg",
      "/images/brasil/serie-a/corinthians/09-10-00-re/cor4.jpg",
    ],
  },
  {
    id: 46,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 09/10 - Uniforme Retro (Laranja)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/09-10-00-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/09-10-00-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/09-10-00-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/09-10-00-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/09-10-00-rt/cor4.jpg",
    ],
  },
  {
    id: 47,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 09/10 - Uniforme 03 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/09-10-03-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/09-10-03-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/09-10-03-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/09-10-03-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/09-10-03-rt/cor4.jpg",
    ],
  },
  {
    id: 48,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 03/04 - Uniforme 2 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/03-04-02-re/cor0.jpg",
      "/images/brasil/serie-a/corinthians/03-04-02-re/cor1.jpeg",
      "/images/brasil/serie-a/corinthians/03-04-02-re/cor2.jpg",
      "/images/brasil/serie-a/corinthians/03-04-02-re/cor3.jpg",
      "/images/brasil/serie-a/corinthians/03-04-02-re/cor4.jpg",
    ],
  },
  {
    id: 49,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 99/00 - Uniforme 3 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/99-00-03-re/cor0.jpg",
      "/images/brasil/serie-a/corinthians/99-00-03-re/cor1.jpg",
      "/images/brasil/serie-a/corinthians/99-00-03-re/cor2.jpg",
      "/images/brasil/serie-a/corinthians/99-00-03-re/cor3.jpg",
      "/images/brasil/serie-a/corinthians/99-00-03-re/cor4.jpg",
    ],
  },
  {
    id: 50,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 98/99 - Uniforme 1 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/98-99-01-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/98-99-01-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/98-99-01-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/98-99-01-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/98-99-01-rt/cor4.jpg",
    ],
  },
  {
    id: 51,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 98/99 - Uniforme 2 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/98-99-02-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/98-99-02-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/98-99-02-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/98-99-02-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/98-99-02-rt/cor4.jpg",
    ],
  },
  {
    id: 52,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 97/98 - Uniforme 3 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/97-98-03-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/97-98-03-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/97-98-03-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/97-98-03-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/97-98-03-rt/cor4.jpg",
    ],
  },
  {
    id: 53,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 97/98 - Uniforme 1 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/95-96-01-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/95-96-01-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/95-96-01-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/95-96-01-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/95-96-01-rt/cor4.jpg",
    ],
  },
  {
    id: 54,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 97/98 - Uniforme 2 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/95-96-00-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/95-96-00-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/95-96-00-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/95-96-00-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/95-96-00-rt/cor4.jpg",
    ],
  },
  {
    id: 55,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 94/95 - Uniforme 1 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/94-95-01-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/94-95-01-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/94-95-01-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/94-95-01-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/94-95-01-rt/cor4.jpg",
    ],
  },
  {
    id: 56,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 94/95 - Uniforme 2 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/94-95-02-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/94-95-02-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/94-95-02-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/94-95-02-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/94-95-02-rt/cor4.jpg",
    ],
  },
  {
    id: 57,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 92/93 - Uniforme 2 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/92-93-02-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/92-93-02-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/92-93-02-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/92-93-02-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/92-93-02-rt/cor4.jpg",
    ],
  },
  {
    id: 58,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians 90/91 - Uniforme 2 Retro",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "retro",
      "corinthians retro",
      "retro corinthians",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/corinthians/90-91-02-rt/cor0.jpg",
      "/images/brasil/serie-a/corinthians/90-91-02-rt/cor1.jpg",
      "/images/brasil/serie-a/corinthians/90-91-02-rt/cor2.jpg",
      "/images/brasil/serie-a/corinthians/90-91-02-rt/cor3.jpg",
      "/images/brasil/serie-a/corinthians/90-91-02-rt/cor4.jpg",
    ],
  },
  {
    id: 59,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians - Jaqueta (Amarela/Preta)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "jaqueta",
      "corinthians jaqueta",
      "jaqueta corinthians",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/jap/cor0.jpg",
      "/images/brasil/serie-a/corinthians/jap/cor1.jpg",
      "/images/brasil/serie-a/corinthians/jap/cor2.jpg",
      "/images/brasil/serie-a/corinthians/jap/cor3.jpg",
    ],
  },
  {
    id: 60,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians - Jaqueta (Branca)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "jaqueta",
      "corinthians jaqueta",
      "jaqueta corinthians",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/jb/cor0.jpg",
      "/images/brasil/serie-a/corinthians/jb/cor1.jpg",
      "/images/brasil/serie-a/corinthians/jb/cor2.jpg",
      "/images/brasil/serie-a/corinthians/jb/cor3.jpg",
    ],
  },
  {
    id: 61,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians - Jaqueta Treinador",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "jaqueta",
      "corinthians jaqueta",
      "jaqueta corinthians",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/jc/cor0.jpg",
      "/images/brasil/serie-a/corinthians/jc/cor1.jpg",
      "/images/brasil/serie-a/corinthians/jc/cor2.jpg",
      "/images/brasil/serie-a/corinthians/jc/cor3.jpg",
      "/images/brasil/serie-a/corinthians/jc/cor4.jpg",
    ],
  },
  {
    id: 62,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians - Jaqueta (Preta)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "jaqueta",
      "corinthians jaqueta",
      "jaqueta corinthians",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/jp/cor0.jpg",
      "/images/brasil/serie-a/corinthians/jp/cor1.jpg",
      "/images/brasil/serie-a/corinthians/jp/cor2.jpg",
      "/images/brasil/serie-a/corinthians/jp/cor3.jpg",
    ],
  },
  {
    id: 63,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians - Jaqueta (Preta/Branca)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "jaqueta",
      "corinthians jaqueta",
      "jaqueta corinthians",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/jpb/cor0.jpg",
      "/images/brasil/serie-a/corinthians/jpb/cor1.jpg",
      "/images/brasil/serie-a/corinthians/jpb/cor2.jpg",
      "/images/brasil/serie-a/corinthians/jpb/cor3.jpg",
      "/images/brasil/serie-a/corinthians/jpb/cor4.jpg",
    ],
  },
  {
    id: 64,
    pais: "brasil",
    liga: "serie-a",
    time: "corinthians",
    nome: "Corinthians - Jaqueta (Roxa)",
    aliases: [
      "corinthians",
      "timão",
      "coringão",
      "jaqueta",
      "corinthians jaqueta",
      "jaqueta corinthians",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/corinthians/jr/cor0.jpg",
      "/images/brasil/serie-a/corinthians/jr/cor1.jpg",
      "/images/brasil/serie-a/corinthians/jr/cor2.jpg",
      "/images/brasil/serie-a/corinthians/jr/cor3.jpg",
      "/images/brasil/serie-a/corinthians/jr/cor4.jpg",
    ],
  },
];

export default corinthians;
